module.exports = __webpack_public_path__ + "img/cb.9aa760b0.svg";